import { useCallback } from 'react'
import { useAppDispatch } from '../../store/hooks'
import { planApi } from '../../store/plan/plan'

export const useRefreshSeats = (): (() => void) => {
  const dispatch = useAppDispatch()

  return useCallback(() => {
    dispatch(planApi.util.invalidateTags(['BillingCustomer']))
  }, [dispatch])
}
